import { render } from "./BenefitsTotal.vue?vue&type=template&id=0c21a303&scoped=true&ts=true"
import script from "./BenefitsTotal.vue?vue&type=script&lang=ts"
export * from "./BenefitsTotal.vue?vue&type=script&lang=ts"

import "./BenefitsTotal.vue?vue&type=style&index=0&id=0c21a303&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c21a303"]])

export default __exports__